import { render, staticRenderFns } from "./boleto.vue?vue&type=template&id=423b27da"
import script from "./boleto.vue?vue&type=script&lang=js"
export * from "./boleto.vue?vue&type=script&lang=js"
import style0 from "./boleto.vue?vue&type=style&index=0&id=423b27da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports